<template>
  <div>
    <v-card class="elevation-7 card-style">
      <!-- Company Branding -->
      <CompanyBranding
      :company="company"
      ></CompanyBranding>
      <!-- Login/Sign up heading -->
      <v-card-title primary-title class="justify-center">
        <div class="display-1 primary--text font-weight-light">
          {{ $t("login.title") }}
        </div>
      </v-card-title>
      <!-- Content -->
      <v-stepper v-model="current_step">
        <v-stepper-items>
          <!-- Ask email -->
          <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.LOGIN">
            <AskEmail
            ref="emailForm"
            :email.sync="email"
            @onCancel="goToCompanyHome"
            @onConfirm="checkEmail"
            @loginWithFirebase="loginWithFirebase"
            ></AskEmail>
          </v-stepper-content>

          <!-- Ask passwod if exists -->
          <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.ASK_PASSWORD">
            <AskPassword
            ref="passwordForm"
            :email="email"
            :is_email_verified="is_email_verified"
            :phone="phone"
            :password.sync="password"
            :loading="loading"
            @onChange="goToStep"
            @onReset="resetPassword"
            @onResend="resendVerification"
            @onLoginWithCode="goToStep"
            @onCancel="goToCompanyHome"
            @onConfirm="login"
            ></AskPassword>
          </v-stepper-content>

          <!-- Verification => Ask Otp on email  -->
          <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.VERIFICATION">
            <AskOtpOnEmail
            ref="verificationForm"
            :phone="phone"
            :email="email"
            :is_email_verified="is_email_verified"
            :code="code"
            @onChange="goToStep"
            @onResend="resendVerification"
            @onSetCode="onComplete"
            @onCancel="goToCompanyHome"
            @onConfirm="verifyOTP"
            ></AskOtpOnEmail>
          </v-stepper-content>

          <!-- Verification => Ask Otp on phone-->
          <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.ASK_OTP">
            <AskOtpOnPhone
            ref="verificationForm"
            :phone="phone"
            :code="code"
            @onChange="goToStep"
            @onResend="resendVerification"
            @onSetCode="onComplete"
            @onCancel="goToCompanyHome"
            @onConfirm="verifyOTP"
            ></AskOtpOnPhone>
          </v-stepper-content>

          <!-- Ask name & phone  -->
          <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.ASK_NAME_AND_PHONE">
            <AskBasicDetails
            v-if="consumer"
            ref="basicDetailsForm"
            :name.sync="consumer.name"
            :phone.sync="consumer.phone"
            :country_code="country_code"
            @onConfirm="updateConsumer"
            ></AskBasicDetails>
          </v-stepper-content>

          <!-- Ask phone  -->
          <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.ASK_PHONE">
            <AskPhone
            :country_code="country_code"
            @onChange="goToStep"
            @onSetPhone="setPhoneNumber"
            @onCancel="goToCompanyHome"
            @onConfirm="resetPassword"
            ></AskPhone>
          </v-stepper-content>

          <!-- Ask to set password -->
          <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.WANT_TO_SET_PASSWORD">
            <AskToSetPassword
            @onSkip="afterSkipPassword"
            @onConfirm="goToStep"
            ></AskToSetPassword>
          </v-stepper-content>

          <!-- Change password -->
          <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.CHANGE_PASSWORD">
            <ChangePassword
            ref="changePasswordForm"
            :password.sync="password"
            :confirm_password.sync="confirm_password"
            @onCancel="afterSkipPassword"
            @onConfirm="changePassword"
            ></ChangePassword>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </div>
</template>
<script>
import DEFINES from "@/defines";
import { mapState, mapGetters } from "vuex";
import { userCountryCode } from "@/mixins/userCountryCode";
import { consumerAuthentication } from "@/mixins/consumerAuthentication";
import AskEmail from "@/components/screener/enrollment/AskEmail";
import AskPassword from "@/components/screener/enrollment/AskPassword";
import AskOtpOnEmail from "@/components/screener/enrollment/AskOtpOnEmail";
import AskOtpOnPhone from "@/components/screener/enrollment/AskOtpOnPhone";
import AskBasicDetails from "@/components/screener/enrollment/AskBasicDetails";
import AskPhone from "@/components/screener/enrollment/AskPhone";
import AskToSetPassword from "@/components/screener/enrollment/AskToSetPassword";
import ChangePassword from "@/components/screener/enrollment/ChangePassword"
import CompanyBranding from "@/components/company/Branding"

export default {
  name: "Enrollment",
  props: ["dialog", "screener", "pricing"],
  components: {
    AskEmail,
    AskPassword,
    AskOtpOnEmail,
    AskOtpOnPhone,
    AskBasicDetails,
    AskPhone,
    AskToSetPassword,
    CompanyBranding,
    ChangePassword,
  },
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      vm.getCountryCode();
    });
  },
  data() {
    return {
      current_step: this.DEFINES.ENROLLMENT_STEPS.LOGIN,
      email: "",
      password: "",
      confirm_password: "",
      phone: null,
      otp: null,
      loading: false,
      complete: false,
      country_code: DEFINES.DEFAULT_COUNTRY_CODE,
      is_email_verified: false,
      code:null,
      resettingPassword:false,
      isPhoneValid:false
    };
  },

  computed: {
    ...mapState({
      company: (state) => state.company.company,
      session_key: (state) => state.auth.key,
      consumer: (state) => state.consumer.profile,
      referrerUrl: (state) => state.app.referrerURL,
    }),
    ...mapGetters("company", {
      currentCompanyID: "getNavigationParamOfCompany",
    }),
    ...mapGetters("app", {
      isNetfestVod: "isNetfestVod"
    }),
  },
  mixins: [userCountryCode,consumerAuthentication],
  methods: {
    onComplete(code) {
      this.otp = code;
      this.verifyOTP();
    },
    async login() {
      try {
        if (!this.$refs.passwordForm.validate()) {
          return false;
        }
        this.loading = true;
        await this.$store.dispatch("auth/login", {
          email: this.email,
          password: this.password,
          company_id: this.company.id,
        });
        this.loading = false;
        await this.loginSuccess();
      } catch (error) {
        this.loading = false;
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async verifyOTP() {
      let __this = this
      try {
        if (!this.$refs.verificationForm.validate()) {
          return false;
        }
        await this.$store
          .dispatch("auth/verifyOTP", {
            otp: this.otp,
            key: this.session_key,
            company_id: this.company.id,
          })
          .then((response) => {
            if(response.consumer && !response.consumer.name)
            {
              return this.current_step = DEFINES.ENROLLMENT_STEPS.ASK_NAME_AND_PHONE;
            }
            if ((!response.has_password && !response.consumer.is_password_skipped) || this.resettingPassword) {
              this.current_step = DEFINES.ENROLLMENT_STEPS.WANT_TO_SET_PASSWORD;
            } else {
              // It redirects to user's dashboard with welcome msg
              this.loginSuccess();
            }
          });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async changePassword() {
      try {
        if (!this.$refs.changePasswordForm.validate()) {
          return false;
        }
        this.matchPasswords();
        this.resettingPassword = false;
        await this.$store.dispatch("consumer/changePassword", {
          password: this.password,
        });
        await this.loginSuccess();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async afterSkipPassword() {
      if(!this.consumer.is_password_skipped){
        this.consumer.is_password_skipped = true;
        this.doUpdateConsumer();
      }
      this.resettingPassword = false;
      await this.loginSuccess();
    },
    async loginSuccess(){
       await this.$store.dispatch("auth/loginSuccess", {
        company_id: this.company.id,
        company_title: this.company.title
      });
    },
    goToConsumerDashboard() {
      this.$router.push({
        name: "user.dashboard"
      });
    },
    setPhoneNumber(payload) {
      if (payload.formattedNumber) {
        this.phone = payload.formattedNumber;
        this.isPhoneValid = payload.isValid;
      }
    },
    async getCountryCode() {
      this.country_code = await this.getUserCountryCode();
    },
    goToCompanyHome() {

      if (this.isNetfestVod) {
        return window.open(this.referrerUrl, '_self');
      }
      
      // TEMP FIX: on cencel redirect to third party website in case on oauth
      if(this.$route.query && this.$route.query.redirect_url){
          let redirect_pah = this.$route.query.redirect_url.split("?")[0]
          window.location = redirect_pah;
      } else {
        this.$router.push({
          name: "company.dashboard",
        });
      }
    },
    goToStep(step){
      this.current_step = step;
    },
    async loginWithFirebase(payload)
    {
      await this.$store.dispatch('auth/loginWithFirebase',{
        provider: 'google', //Using google provider by default
        accessToken: payload.credential.idToken,
        company_id: this.company.id,
      })
      .then((response) => {
        
        this.loginSuccess();
      })
      .catch((error) => {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      })
    },
  },
};
</script>
<style scoped>
.card-style {
  border-radius: 10px !important;
  border-top: 5px solid var(--v-primary-base) !important;
}
</style>
